import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ValueProp from './components/ValueProp';
import StockGrid from './components/StockGrid';
import InvestingForEveryone from './components/InvestingForEveryone';
import ComparisonTable from './components/ComparisonTable';
import Features from './components/Features';
import SettingStandards from './components/SettingStandards';
import StockMarquee from './components/StockMarquee';
import CTASection from './components/CTASection';
import FAQ from './components/FAQ';
import Issuers from './components/Issuers';
import LearnMore from './components/LearnMore';
import Footer from './components/Footer';
import Explorer from './pages/Explorer';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Article from './pages/Article';

const HomePage = () => (
  <div className="min-h-screen bg-[#0b0014]">
    <Header />
    <main>
      <Hero />
      <ValueProp />
      <Issuers />
      <StockGrid />
      <InvestingForEveryone />
      <ComparisonTable />
      <Features />
      <SettingStandards />
      <StockMarquee />
      <CTASection />
      <FAQ />
      <LearnMore />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/explorer" element={<Explorer />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/learn/:slug" element={<Article />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
